module.exports = __webpack_public_path__ + "img/dwight-d.-eisenhower.1d11fac5.png";